'use client';

export { CatalogFilters, type CatalogFiltersProps } from './ui/catalog-filters';
